// extracted by mini-css-extract-plugin
export var standaloneTable = "_e1-0";
export var standaloneTableWithBodyFill = "_e1-1";
export var withExtraHeader = "_e1-2";